/**
 * Computes the SHA-256 digest of one already-assembled segment, hex-encoded in lowercase, without
 * prefix, always 64 characters (zero-padded per byte). This is the only encoding this port's
 * integrity barrier ever compares: a caller producing any other encoding for the very same bytes —
 * base64, uppercase, or a byte left unpadded — never matches this string, so the comparison fails
 * closed. No bytes get deleted, and the mismatch stays invisible to a test that only ever compares
 * this function against itself.
 *
 * `subtleCrypto` is injected and defaulted from the global at call time, never assumed to be a
 * polyfill already sitting on `globalThis`.
 */
const computeSegmentDigestHex = async (
	segment: Blob,
	subtleCrypto: SubtleCrypto | undefined = globalThis.crypto?.subtle,
): Promise<string> => {
	if (subtleCrypto === undefined) {
		throw new Error("Le calcul de condensat n'est pas disponible sur cet appareil.");
	}

	const segmentBytes = await segment.arrayBuffer();
	const digestBuffer = await subtleCrypto.digest('SHA-256', segmentBytes);
	const digestBytes = new Uint8Array(digestBuffer);
	const hexDigits: string[] = [];

	for (const byteValue of digestBytes) {
		hexDigits.push(byteValue.toString(16).padStart(2, '0'));
	}

	return hexDigits.join('');
};

export default computeSegmentDigestHex;
